<template>
  <div class="search-content">
    <Navbar :appTitle="title" :rtitle="rtitle" :rname="rname" />
    <div class="formgroup" v-for="(item,index) in columns" :key="index" >
      <span class="title">{{item.columnName}}</span>
      <!-- <van-field
        is-link
        readonly
        name="picker"
        @click="chooseUser"
        
        placeholder="请选择"
        v-if="item.groupType=='input'"
      >
      </van-field> -->
      <van-field v-model="params[item.backColumn]" label="请输入" v-if="item.groupType=='input'" :backColumn="item.backColumn" />
      <van-field v-model="params[item.backColumn]" v-if="item.groupType=='select'"
       clickable @click="showPickerMethod" label="请选择"
       placeholder="请选择" input-align="right" right-icon="arrow"/>   

    </div>
    
  
     <!-- <upload  iconType="fj" @fileChange="fileChange"
     :fileIds="fileIds"
     ></upload> -->
    <div class="search-bottom">
      <span class="btncancel" @click="cancel">取消</span>
      <span class="btnconfirm" @click="confirm">确定</span>
    </div>

    <!--申请类型-->
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        title="选择状态"
        @cancel="cancleSelect"
        @confirm="confirmSelect"
      />
    </van-popup>
  </div>
</template>

<script>
let formObj={}
import Navbar from "@/components/navBar/navBar_right";
import ContactPickers from "@/components/choiceuse/ContactPickers";
import moment from "moment";
export default {
  name: "search",
  components: { Navbar, ContactPickers},
  data() {
    return {
      columns:[],
      showPicker:false,
      title: this.$route.meta.title,
      fzrVisible: false,
      ddthrVisible: false,
      promiseDateStartVisible: false,
      promiseDateEndVisible: false,
      createdTimeBeginVisible:false,
      createdTimeEndVisible:false,
      fzrName: "", //生产负责人
      createdByName: "", //订单提交人
      rtitle: "",
      rname: "", //search
      fileIds:"1509889200026275842,1510083205250818050,1509894546648190978",
      minDate: new Date(2020, 1, 1),
      maxDate: new Date(2025, 10, 1),
      params: Object.assign({}, formObj)
      
    };
  },
  computed: {},
  mounted() {

    this.columns=this.$store.state.serachPrams.columns
    this.columns.forEach(item=>{
      formObj[item.backColumn]=""
      console.log(formObj)
    })
    console.log("dsasdasdasdasdasdasd")
  },
  created() {
   
    // console.log(this.$store.state)
    // console.log(this.columns)
  },
  methods: {
    showPickerMethod(item){
       this.showPicker=true
       this.columns=item.options
    },
    cancleSelect(){
       this.showPicker=false
    },
    confirmSelect(){
       this.showPicker=false
    },
    fileChange(ids){
      console.log("父组件"+ids)
    },
    confirmPromiseStartTime(date) {
      this.params.promiseDateBegin = moment(date).format("YYYY-MM-DD HH:mm");
      console.log(date);
      console.log(this.params.promiseDateBegin);
      this.promiseDateStartVisible = false;
    },
    cancelPromiseStartTime() {
      this.params.promiseDateBegin = "";
      this.promiseDateStartVisible = false;
    },
    confirmPromiseEndTime(date){
      this.params.promiseDateEnd = moment(date).format("YYYY-MM-DD HH:mm");
      console.log(date);
      console.log(this.params.promiseDateEnd);
      this.promiseDateEndVisible = false;
    },
    cancelPromiseEndTime(){
      this.params.promiseDateEnd = "";
      this.promiseDateEndVisible = false;
    },
    confirmCreatedStartTime(date){
      this.params.createdTimeBegin = moment(date).format("YYYY-MM-DD HH:mm");
      console.log(date);
      console.log(this.params.createdTimeBegin);
      this.createdTimeBeginVisible = false;
    },
    cancelCreatedStartTime(){
      this.createdTimeBeginVisible = false;
      this.params.createdTimeBegin=""
    },
    confirmCreatedEndTime(date){
      this.params.createdTimeEnd = moment(date).format("YYYY-MM-DD HH:mm");
      console.log(date);
      console.log(this.params.createdTimeEnd);
      this.createdTimeEndVisible = false;
    },
    cancelCreatedEndTime(){
       this.createdTimeEndVisible = false;
       this.params.createdTimeEnd="";
    },
    formatter(type, val) {
      if (type === "year") {
        return val + "年";
      }
      if (type === "month") {
        return val + "月";
      }
      if (type === "day") {
        return val + "日";
      }
      if (type === "hour") {
        return val + "时";
      }
      if (type === "minute") {
        return val + "分";
      }
      return val;
    },
    chooseUser() {
      this.fzrVisible = true;
    },
    confirmChooseUsers(val, selectedList, judge) {
      this.params.chargeUserId = "";
      this.fzrName = "";
      if (judge) {
        this.fzrVisible = false;
        return;
      }
      this.params.chargeUserId = val ? val : ""; //人员id
      let arr = [];
      if (selectedList) {
        selectedList.forEach((item) => {
          arr.push(item.realname);
        });
      }
      this.fzrName = arr.join(",");
      this.fzrVisible = false;
    },
    confirmDdtjr(val, selectedList, judge) {
      this.params.createdBy = "";
      this.createdByName = "";
      if (judge) {
        this.ddthrVisible = false;
        return;
      }
      this.params.createdBy = val ? val : ""; //人员id
      let arr = [];
      if (selectedList) {
        selectedList.forEach((item) => {
          arr.push(item.realname);
        });
      }
      this.createdByName = arr.join(",");
      this.ddthrVisible = false;
    },
    cancel() {},
    confirm() {
      console.log(this.params)
      // this.$router.push({ path: "/carRoomList" });
    },
  },
};
</script>
<style lang="scss" scoped>
.search-content {
   padding-bottom: 0.5rem;
  .formgroup {
    background: #ffffff;
    // padding: 0 0.16rem;
    margin-bottom: 0.2rem;
    padding-top: 0.1rem;
    border-bottom: 1px solid #F2F2F2;

    .title {
      width: 0.58rem;
      height: 0.14rem;
      font-size: 0.15rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #191f25;
      line-height: 0.05rem;
      margin-left: 0.16rem;
    }
  }
  .search-bottom {
    height: 0.5rem;
    width: 100%;
    background: #ffffff;
    // background: red;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0px;
    padding: 0.11rem;
    .btnconfirm {
      width: 1.72rem;
      height: 0.39rem;
      background: #1890ff;
      border-radius: 0rem;
      text-align: center;
      line-height: 0.39rem;
    }
    .btncancel {
      width: 1.72rem;
      height: 0.39rem;
      background: #f6f6f6;
      border: 0.01px solid rgba(25, 31, 37, 0.12);
      border-radius: 0rem;
      text-align: center;
      line-height: 0.39rem;
    }
  }
}
</style>